import { render } from "./HeroiconsOutlineFolderOpen.vue?vue&type=template&id=6df84cb6"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderOpen.vue"]])

export default __exports__